import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { GET } from '../../api';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { TransactionHistoryRequest } from './transactionhistoryrequest';

export class TransactionHistoryAPI extends SixdeeCRBTAPI<TransactionHistoryRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return GET;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/view-transactions-scm
        return "view-transactions-scm"+"?"+"msisdn="+ this.getRequest().getTransactionHistoryRequest().getMsisdn()+"&"+
               "fromDate="+ this.getRequest().getTransactionHistoryRequest().getFromDate()+"&"+
               "toDate="+ this.getRequest().getTransactionHistoryRequest().getToDate();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/myaccount/transactionhistory/transactionhistoryapi.tsx